import(/* webpackMode: "eager" */ "/personal-project/components/site-header.tsx")